import React, { useState, useEffect } from "react";
import Dialog from "@mui/material/Dialog";
import DialogTitle from "@mui/material/DialogTitle";
import DialogContent from "@mui/material/DialogContent";
import DialogActions from "@mui/material/DialogActions";
import Grid from "@mui/material/Grid";
import MDButton from "components/MDButton";
import MDInput from "components/MDInput";
import MDBox from "components/MDBox";
import MDTypography from "components/MDTypography";
import { PersonAdd, Loop } from "@mui/icons-material";
import { useAddSupervisor } from "hooks/useAddSupervisor";
import styled, { keyframes } from "styled-components";
import { toast } from "sonner";

const spin = keyframes`
  0% { transform: rotate(0deg); }
  100% { transform: rotate(360deg); }
`;

const RotatingLoop = styled(Loop)`
  animation: ${spin} 1s linear infinite;
`;

const AddSupervisorPopup = () => {
  const [open, setOpen] = useState(false);
  const [firstname, setFirstname] = useState("");
  const [lastname, setLastname] = useState("");
  const [email, setEmail] = useState("");
  const [password, setPassword] = useState("");
  const [confirmPassword, setConfirmPassword] = useState("");
  const { addsupervisor, error, isLoading, success, setError, setSuccess } =
    useAddSupervisor();

  // Close the dialog 2 seconds after a successful submission
  useEffect(() => {
    if (success) {
      const timer = setTimeout(() => {
        handleClose();
      }, 3000); // 2000ms = 2 seconds

      return () => clearTimeout(timer); // Clear timeout if component unmounts or success changes
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [success]);

  const handleSubmit = async (e) => {
    e.preventDefault();

    await addsupervisor(firstname, lastname, email, password, confirmPassword);
  };

  const handleClickOpen = () => {
    setOpen(true);
  };

  const handleClose = () => {
    setOpen(false);
    //clear all fields
    setFirstname("");
    setLastname("");
    setEmail("");
    setPassword("");
    setConfirmPassword("");
    // Clear error on close
    setError(null);
    setSuccess(null);
  };

  useEffect(() => {
    if (error) {
      toast.error("Error", { description: error });
    }

    if (success) {
      toast.success("Success", { description: success });
    }
  }, [success, error]);

  return (
    <div>
      <MDButton
        variant="gradient"
        color="info"
        size="small"
        startIcon={<PersonAdd />}
        onClick={handleClickOpen}
      >
        Add Supervisor
      </MDButton>
      <Dialog open={open} onClose={handleClose} maxWidth="sm" fullWidth>
        <DialogTitle>Add Supervisor</DialogTitle>
        <DialogContent>
          <Grid container spacing={2}>
            <Grid item xs={6}>
              <MDInput
                fullWidth
                label="First Name"
                name="firstName"
                variant="standard"
                value={firstname}
                onChange={(e) => setFirstname(e.target.value)}
              />
            </Grid>
            <Grid item xs={6}>
              <MDInput
                fullWidth
                label="Last Name"
                name="lastName"
                variant="standard"
                value={lastname}
                onChange={(e) => setLastname(e.target.value)}
              />
            </Grid>
            <Grid item xs={12}>
              <MDInput
                fullWidth
                label="Email"
                name="email"
                variant="standard"
                value={email}
                onChange={(e) => setEmail(e.target.value)}
              />
            </Grid>
            <Grid item xs={6}>
              <MDInput
                fullWidth
                label="Password"
                name="password"
                type="password"
                variant="standard"
                value={password}
                onChange={(e) => setPassword(e.target.value)}
              />
            </Grid>
            <Grid item xs={6}>
              <MDInput
                fullWidth
                label="Confirm Password"
                name="confirmPassword"
                type="password"
                variant="standard"
                value={confirmPassword}
                onChange={(e) => setConfirmPassword(e.target.value)}
              />
            </Grid>
          </Grid>
        </DialogContent>
        <DialogActions>
          <MDButton onClick={handleClose}>Cancel</MDButton>
          <MDButton
            onClick={handleSubmit}
            variant="contained"
            color="primary"
            disabled={isLoading}
            startIcon={isLoading && <RotatingLoop />}
          >
            Submit
          </MDButton>
        </DialogActions>
      </Dialog>
    </div>
  );
};

export default AddSupervisorPopup;
